import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {ArrowDown1} from "@reviewpush/streamline-bold/lib/arrows-diagrams/Arrows";
import {white} from 'style/_colors.scss';


export default {
    props: {
        size: {
            type: String,
            default: 'sm',
            validator: (val) => ['sm', 'lg'].indexOf(val) !== -1,
        },
        numSize: {
            type: Number,
            default: 8
        },
        direction: {
            type: String,
            required: true,
            validator: (dir) => ['left', 'right'].indexOf(dir) !== -1
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        StreamlineIcon
    },
    methods: {
        onClick(){
            if(!this.disabled) {
                this.$emit(this.direction === 'left' ? 'page-left' : 'page-right');
            }
        }
    },
    render(h){
        return h(
            'button',
            {
                class: {
                    'NavArrow': true,
                    'NavArrow--left': this.direction === 'left',
                    'NavArrow--right': this.direction === 'right',
                    'NavArrow--disabled': this.disabled,
                    [`NavButton--${this.size}`]: true,
                },
                on: {
                    click: this.onClick
                }
            },
            [
                h(StreamlineIcon, {
                    class: {
                        'NavArrow__arrow': true,
                        'NavArrow__arrow--left': this.direction === 'left',
                        'NavArrow__arrow--right': this.direction === 'right',
                    },
                    attrs: {
                        icon: ArrowDown1,
                        size: this.numSize,
                        fill: white,
                    },
                }),
            ]
        );
    }
};
